import * as React from "react";

function SvgPhone(props) {
  return (
    <svg
    {...props}

      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2789 3.68272L18.4262 0.832721C18.078 0.484507 17.6119 0.288971 17.1191 0.288971C16.6262 0.288971 16.1602 0.481828 15.8119 0.832721L12.7396 3.89969C12.3914 4.2479 12.1959 4.71665 12.1959 5.20951C12.1959 5.70504 12.3887 6.16844 12.7396 6.51933L15.1396 8.92201C14.5929 10.1959 13.8073 11.3533 12.8253 12.3318C11.8423 13.3202 10.6932 14.0997 9.41819 14.6515L7.01819 12.2488C6.66998 11.9006 6.20391 11.705 5.71105 11.705C5.46795 11.7041 5.22712 11.7518 5.00266 11.8451C4.77821 11.9385 4.57465 12.0757 4.40391 12.2488L1.32891 15.3158C0.980692 15.664 0.785156 16.1327 0.785156 16.6256C0.785156 17.1211 0.978013 17.5845 1.32891 17.9354L4.17891 20.7854C4.77355 21.38 5.59319 21.7202 6.43426 21.7202C6.60837 21.7202 6.77712 21.7068 6.94855 21.6774C10.495 21.0934 14.0146 19.205 16.8566 16.3658C19.6959 13.5211 21.5816 10.0015 22.1709 6.45236C22.3396 5.44522 22.0021 4.40861 21.2789 3.68272V3.68272ZM20.2718 6.13361C19.7494 9.29165 18.0512 12.4417 15.4932 14.9997C12.9352 17.5577 9.78784 19.2559 6.6298 19.7783C6.23337 19.8452 5.82623 19.7113 5.53694 19.4247L2.73783 16.6256L5.70569 13.655L8.91462 16.8693L8.93873 16.8934L9.5173 16.6792C11.2716 16.0342 12.8646 15.0154 14.186 13.6936C15.5074 12.3717 16.5256 10.7783 17.17 9.02379L17.3843 8.44522L14.1486 5.21219L17.1164 2.24165L19.9155 5.04076C20.2048 5.33004 20.3387 5.73719 20.2718 6.13361Z"
        fill="#131B1F"
      />
    </svg>
  );
}

export default SvgPhone;
